const trains = {
  train: "Treno", // translated
  trains: "Treni", // translated
  fairConditions: "Condizioni eque", // translated
  to: "A", // translated
  earlier: "Prima", // translated
  later: "Dopo", // translated
  adults: "Adulti", // translated
  child: "Bambino", // translated
  senior: "Anziano", // translated
  seniors: "Gli anziani", // translated
  price: "Prezzo", // translated
  for: "per", // translated
  total: "Totale", // translated
  selected: "Selezionato", // translated
  prebook: "Prenota in anticipo", // translated
  book: "Libro", // translated
  payment: "Pagamento", // translated
  return: "Ritorno", // translated
  passengers: "Passeggeri", // translated
  delivery: "Consegna", // translated
  summary: "Riepilogo", // translated
  checkout: "Guardare", // translated
  trainToastCorrectFillForm: "Ti preghiamo di compilare correttamente tutti i campi.", // translated
  fareConditions: "Condizioni tariffarie", // translated
  travelInfo: "Informazioni di viaggio", // translated
  remarks: "Osservazioni del cliente", // translated
  noServices: "Nessun servizio", // translated
  timesAndSeats: "Orari e posti", // translated
  mobileTicket: "Biglietto mobile", // translated
  stationTicket: "Ritiro alla stazione", // translated
  homeTicket: "Stampa a casa", // translated
  countryCode: "Prefisso internazionale", // translated
  chooseTicket: "Scegli la modalità di consegna del biglietto", // translated
  ticketError: "Seleziona un biglietto per tutte le destinazioni", // translated
  ticketDelivery: "Seleziona un metodo di consegna del biglietto", // translated
  passengerDetails: "Dettagli del passeggero", // translated
  waitWhileProcessingPayment: "Ti preghiamo di attendere mentre elaboriamo il pagamento, non aggiornare o chiudere la pagina.", // translated
  reductionCardId: "ID della carta di riduzione", // translated
  countryOfResidence: "Paese di residenza", // translated
  countryOfBirth: "Paese di nascita", // translated
  documentCountry: "Paese del documento", // translated
  documentNumber: "Numero del documento", // translated
  expirationDate: "Data di scadenza", // translated
  documentType: "Tipo di documento", // translated
  travelerDocumentInfo: "Informazioni sui documenti del viaggiatore", // translated
  youth: "Gioventù", // translated
  youths: "Giovani", // translated
  departTimeEarlyFirst: "Orario di partenza (prima il più presto possibile)", // translated
};


export default trains;
